// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__Q9ep7","empty":"ModalGraph_empty__1SmyQ"};